import { HomeIcon, ShieldCheckIcon } from "@heroicons/react/24/outline";

/**
 * 對話頁面導航欄
 * 顯示 Logo、助手資訊和選單按鈕
 * 完全匹配 chat.html 的樣式和功能
 */
export function ConversationMenuModal({
  isMenuOpen,
  setIsMenuOpen,
}: {
  isMenuOpen: boolean;
  setIsMenuOpen: (open: boolean) => void;
}) {
  return (
    <>
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-50"
          onClick={() => setIsMenuOpen(false)}
        >
          <div
            className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl p-6 animate-slide-up"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-6"></div>

            <div className="space-y-4">
              <a
                href="#"
                className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <HomeIcon className="w-5 h-5 text-[#6B8E5A]" />
                <span className="text-[#A0956B]">回到首頁</span>
              </a>

              <a
                href="#"
                className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <ShieldCheckIcon className="w-5 h-5 text-[#6B8E5A]" />
                <span className="text-[#A0956B]">服務條款</span>
              </a>

              <a
                href="#"
                className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <ShieldCheckIcon className="w-5 h-5 text-[#6B8E5A]" />
                <span className="text-[#A0956B]">隱私政策</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
